import React, { useState, useEffect } from "react";
import "./TestimonialsSection.css";
import YoutubeVideo from "../common/YoutubeVideo";

const TestimonialsSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(3);
  const totalSlides = 6;
  const videos = [
    "RZ8aXlUTlEk", "EGSCB3G-Iu0", "UnaJBI_bPiY", "1Zga7vpYEu8", "h3An7ycxxdI", "57D1vwZVz0M"
  ];

  useEffect(() => {
    const calculateSlidesToShow = () => {
      const screenWidth = window.innerWidth;
      if (screenWidth < 768) {
        setSlidesToShow(1);
      } else if (screenWidth < 1024) {
        setSlidesToShow(2);
      } else {
        setSlidesToShow(3);
      }
    };
    
    calculateSlidesToShow();
    window.addEventListener("resize", calculateSlidesToShow);
    
    return () => {
      window.removeEventListener("resize", calculateSlidesToShow);
    };
  }, []);

  const nextSlide = () => {
    if (currentSlide < totalSlides - slidesToShow) {
      setCurrentSlide(currentSlide + 1);
    }
  };

  const previousSlide = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    }
  };

  const goToSlide = (index) => {
    setCurrentSlide(Math.max(0, Math.min(index, totalSlides - slidesToShow)));
  };

  const cardWidth = 380;
  const gap = 32;
  const totalWidth = cardWidth + gap;

  return (
    <section className="section" id="testimonials">
      <div className="container">
        <h2 className="section-title">Testimonials and Featured Productions</h2>
        <div className="testimonials-carousel">
          <div 
            className="testimonials-track" 
            style={{ transform: `translateX(-${currentSlide * totalWidth}px)` }}
          >
            {videos.map((vid, idx) => (
              <div className="testimonial-card" key={idx}>
                <YoutubeVideo videoId={vid} />
              </div>
            ))}
          </div>
        </div>

        <div className="carousel-nav">
          <button 
            className="carousel-btn" 
            onClick={previousSlide}
            disabled={currentSlide === 0}
          >‹</button>
          
          <div className="carousel-dots">
            {Array.from({ length: Math.max(0, totalSlides - slidesToShow + 1) }).map((_, i) => (
              <button
                key={i}
                className={`carousel-dot ${i === currentSlide ? "active" : ""}`}
                onClick={() => goToSlide(i)}
              />
            ))}
          </div>
          
          <button 
            className="carousel-btn" 
            onClick={nextSlide}
            disabled={currentSlide >= totalSlides - slidesToShow}
          >›</button>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
